import Vue from 'vue'
import Router from 'vue-router'
import loadcomponents from '@/tools/loadcomponents'
import store from '../store'
import getLocal from '@/common/cookie'
import eventBus from '@/utils/eventBus'
const routes = [
  {
    path: '/login',
    name: 'login',
    component: loadcomponents.load('login', 'views', ''),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: loadcomponents.load('login/register', 'views', ''),
    meta: {
      title: '注册'
    }
  },
  {
    path: '/oldhome',
    name: 'home',
    component: loadcomponents.load('home', 'views', ''),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/',
    name: 'newhome',
    component: loadcomponents.load('newhome', 'views', ''),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/resources',
    name: 'resources',
    component: loadcomponents.load('resources', 'views', ''),
    meta: {
      title: '资源'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: loadcomponents.load('home', 'views', ''),
    meta: {
      title: '首页'
    }
  }, {
    path: '/home1',
    name: 'home',
    component: loadcomponents.load('formwork1', 'views', '/home'),
    meta: {
      title: '首页'
    }
  }, {
    path: '/aboutacademy',
    name: 'aboutacademy',
    component: loadcomponents.load('aboutacademy', 'views', ''),
    meta: {
      title: '帮助中心'
    },
    children: [
      {
        path: '/leader',
        name: 'leader',
        component: loadcomponents.load('leader', 'views', '/aboutacademy'),
        meta: {
          title: '学会章程'
        }
      }, {
        path: '/contentlist',
        name: 'contentlist',
        component: loadcomponents.load('contentlist', 'views', '/aboutacademy'),
        meta: {
          title: '资讯通知'
        }
      }, {
        path: '/contentdetail',
        name: 'contentdetail',
        component: loadcomponents.load('contentdetail', 'views', '/aboutacademy'),
        meta: {
          title: '规章详情'
        }
      }
    ]
  }, {
    path: '/learndynamics',
    name: 'learndynamics',
    component: loadcomponents.load('learndynamics', 'views', ''),
    meta: {
      title: '学会动态'
    }
  }, {
    path: '/course',
    name: 'course',
    component: loadcomponents.load('course', 'views', ''),
    meta: {
      title: '课程'
    }
  }, {
    path: '/newcourse',
    name: 'newcourse',
    component: loadcomponents.load('studycenter/newcourse', 'views', ''),
    meta: {
      title: '课程',
      requiresAuth: true
    }
  }, {
    path: '/surveyquestion',
    name: 'surveyquestion',
    component: loadcomponents.load('surveyquestion', 'views', ''),
    meta: {
      title: '课程',
      requiresAuth: true
    }
  }, {
    path: '/lecturer',
    name: 'lecturer',
    component: loadcomponents.load('lecturer', 'views', ''),
    meta: {
      title: '授课专家'
    }
  }, {
    path: '/popularcourse',
    name: 'popularcourse',
    component: loadcomponents.load('course/popularcourse', 'views', ''),
    meta: {
      title: '热门课程'
    }
  }, {
    path: '/train',
    name: 'train',
    component: loadcomponents.load('course/train', 'views', ''),
    meta: {
      title: '培训课程'
    }
  },
  // 宁夏相关
  {
    path: '/personneltrain',
    name: 'personneltrain',
    component: loadcomponents.load('personneltrain', 'views', ''),
    meta: {
      title: '人才培养'
    }
  }, {
    path: '/order',
    name: 'order',
    component: loadcomponents.load('course/order', 'views', ''),
    meta: {
      title: '订单详情'
    }
  }, {
    path: '/workersevaluation',
    name: 'workersevaluation',
    component: loadcomponents.load('workersevaluation', 'views', ''),
    meta: {
      title: '职业评价'
    }
  }, {
    path: '/learnresearch',
    name: 'learnresearch',
    component: loadcomponents.load('learnresearch', 'views', ''),
    meta: {
      title: '学术研究'
    }
  }, {
    path: '/workerstandard',
    name: 'workerstandard',
    component: loadcomponents.load('workerstandard', 'views', ''),
    meta: {
      title: '社工标准'
    }
  }, {
    path: '/statutepolicy',
    name: 'statutepolicy',
    component: loadcomponents.load('statutepolicy', 'views', ''),
    meta: {
      title: '法规政策'
    }
  }, {
    path: '/project',
    name: 'project',
    component: loadcomponents.load('project', 'views', ''),
    meta: {
      title: '项目合作'
    }
  }, {
    path: '/projectdetail',
    name: 'projectdetail',
    component: loadcomponents.load('project/projectdetail', 'views', ''),
    meta: {
      title: '项目合作'
    }
  }, {
    path: '/special',
    name: 'special',
    component: loadcomponents.load('special', 'views', ''),
    meta: {
      title: '专题'
    }
  }, {
    path: '/speciallistsecond',
    name: 'speciallistsecond',
    component: loadcomponents.load('special/speciallistsecond', 'views', ''),
    meta: {
      title: '专题二级列表'
    }
  }, {
    path: '/speciallistthird',
    name: 'speciallistthird',
    component: loadcomponents.load('special/speciallistthird', 'views', ''),
    meta: {
      title: '专题三级列表'
    }
  }, {
    path: '/specialdetail',
    name: 'specialdetail',
    component: loadcomponents.load('special/specialdetail', 'views', ''),
    meta: {
      title: '专题详情'
    }
  },
  {
    path: '/secondlist',
    name: 'secondlist',
    component: loadcomponents.load('secondlist', 'views', ''),
    meta: {
      title: '列表页'
    }
  }, {
    path: '/contentmaindetail',
    name: 'contentmaindetail',
    component: loadcomponents.load('contentmaindetail', 'views', ''),
    meta: {
      title: '详情页'
    }
  }, {
    path: '/videozone',
    name: 'videozone',
    component: loadcomponents.load('videozone', 'views', ''),
    meta: {
      title: '视频专区'
    }
  }, {
    path: '/videozonelist',
    name: 'videozonelist',
    component: loadcomponents.load('videozone/videozonelist', 'views', ''),
    meta: {
      title: '视频专区列表'
    }
  },
  {
    path: '/videozonedetail',
    name: 'videozonedetail',
    component: loadcomponents.load('videozone/videozonedetail', 'views', ''),
    meta: {
      title: '视频专区详情'
    }
  },
  {
    path: '/authregister',
    name: 'authregister',
    component: loadcomponents.load('auth/register', 'views', ''),
    meta: {
      title: '会员注册'
    }
  },
  {
    path: '/registerdetail',
    name: 'registerdetail',
    component: loadcomponents.load('auth/register/detail', 'views', ''),
    meta: {
      title: '会员详情页'
    }
  },
  {
    path: '/generalregister',
    name: 'generalregister',
    component: loadcomponents.load('auth/generalregister', 'views', ''),
    meta: {
      title: '普通用户注册'
    }
  },
  {
    path: '/meeting',
    name: 'meeting',
    component: loadcomponents.load('meeting', 'views', ''),
    meta: {
      title: '会议'
    }
  },
  {
    path: '/meetingdetail',
    name: 'meetingdetail',
    component: loadcomponents.load('meeting/detail', 'views', ''),
    meta: {
      title: '会议详情'
    }
  },
  {
    path: '/index_text',
    name: 'index_text',
    component: loadcomponents.load('home/formwork1/index_text', 'views', ''),
    meta: {
      title: '首页测试'
    }
  },
  {
    path: '/index_new',
    name: 'index_new',
    component: loadcomponents.load('home/index_new', 'views', ''),
    meta: {
      title: '首页测试'
    }
  },
  {
    path: '/meetingsignup',
    name: 'meetingsignup',
    component: loadcomponents.load('meeting/signup', 'views', ''),
    meta: {
      title: '会议报名'
    }
  },
  {
    path: '/sitesearch',
    name: 'sitesearch',
    component: loadcomponents.load('sitesearch', 'views', ''),
    meta: {
      title: '全文搜索'
    }
  }, {
    path: '/personalcenter',
    name: 'personalcenter',
    component: loadcomponents.load('personalcenter', 'views', ''),
    meta: {
      title: '个人中心'
    },
    children: [
      {
        path: '/information',
        name: 'information',
        component: loadcomponents.load('information', 'views', '/personalcenter'),
        meta: {
          title: '基本信息'
        }
      }, {
        path: '/permeeting',
        name: 'permeeting',
        component: loadcomponents.load('permeeting', 'views', '/personalcenter'),
        meta: {
          title: '会议/报名管理'
        }
      }, {
        path: '/personaltopic',
        name: 'personaltopic',
        component: loadcomponents.load('personaltopic', 'views', '/personalcenter'),
        meta: {
          title: '课题管理'
        }
      }
    ]
  },
  {
    path: '/editpass',
    name: 'editpass',
    component: loadcomponents.load('auth/generalregister/editpass', 'views', ''),
    meta: {
      title: '修改密码'
    }
  },
  {
    path: '/declaredtopic',
    name: 'declaredtopic',
    component: loadcomponents.load('declaredtopic', 'views', ''),
    meta: {
      title: '申请课题'
    }
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: loadcomponents.load('auth/forgotpassword', 'views', ''),
    meta: {
      title: '找回密码'
    }
  },
  {
    path: '/declared',
    name: 'declared',
    component: loadcomponents.load('declaredtopic/declared', 'views', ''),
    meta: {
      title: '申报课题'
    }
  },
  {
    path: '/studycenter',
    name: 'studycenter',
    component: loadcomponents.load('newstudycenter', 'views', ''),
    // component: loadcomponents.load('studycenter', 'views', ''),
    meta: {
      title: '学习中心',
      requiresAuth: true
    }
  },
  {
    path: '/newstudycenter',
    name: 'newstudycenter',
    component: loadcomponents.load('newstudycenter', 'views', ''),
    meta: {
      title: '学习中心',
      requiresAuth: true
    }
  },
  {
    path: '/newstudycentermobile',
    name: 'newstudycentermobile',
    component: loadcomponents.load('newstudycentermobile', 'views', ''),
    meta: {
      title: '学习中心',
      requiresAuth: true
    }
  },
  {
    path: '/myclass',
    name: 'myclass',
    component: loadcomponents.load('newstudycenter/myclass/index', 'views', ''),
    meta: {
      title: '我的课程',
      requiresAuth: true
    }
  },
  {
    path: '/livecourse',
    name: 'livecourse',
    component: loadcomponents.load('newstudycenter/livecourse/index', 'views', ''),
    meta: {
      title: '我的课程',
      requiresAuth: true
    }
  },
  {
    path: '/myclassmobile',
    name: 'myclassmobile',
    component: loadcomponents.load('newstudycentermobile/myclassmobile/index', 'views', ''),
    meta: {
      title: '我的课程',
      requiresAuth: true
    }
  },
  {
    path: '/historyrecord',
    name: 'historyrecord',
    component: loadcomponents.load('newstudycenter/aiguidance/historyrecord', 'views', ''),
    meta: {
      title: '历史生成记录',
      requiresAuth: true
    }
  },
  {
    path: '/myreport',
    name: 'myreport',
    component: loadcomponents.load('newstudycenter/aiguidance/myreport', 'views', ''),
    meta: {
      title: '我的学习评估报告',
      requiresAuth: true
    }
  },
  {
    path: '/aiguidance',
    name: 'aiguidance',
    component: loadcomponents.load('newstudycenter/aiguidance/index', 'views', ''),
    meta: {
      title: '智能导学',
      requiresAuth: true
    }
  },
  {
    path: '/mylivecoursemobile',
    name: 'mylivecoursemobile',
    component: loadcomponents.load('newstudycentermobile/livecoursemobile/index', 'views', ''),
    meta: {
      title: '我的课程',
      requiresAuth: true
    }
  },
  {
    path: '/profilemobile',
    name: 'profilemobile',
    component: loadcomponents.load('newstudycentermobile/profilemobile/index', 'views', ''),
    meta: {
      title: '我的资料',
      requiresAuth: true
    }
  },
  {
    path: '/certificatemobile',
    name: 'certificatemobile',
    component: loadcomponents.load('newstudycentermobile/certificatemobile/index', 'views', ''),
    meta: {
      title: '我的证书',
      requiresAuth: true
    }
  },
  {
    path: '/changepassword',
    name: 'changepassword',
    component: loadcomponents.load('newstudycentermobile/changepassword/index', 'views', ''),
    meta: {
      title: '修改密码'
    }
  },
  {
    path: '/coursedetail',
    name: 'coursedetail',
    component: loadcomponents.load('studycenter/coursedetail', 'views', ''),
    meta: {
      title: '学习详情'
    }
  },
  {
    path: '/continue',
    name: 'continue',
    component: loadcomponents.load('studycenter/coursedetail/continue', 'views', ''),
    meta: {
      title: '继续学习'
    }
  },
  {
    path: '/starttrain',
    name: 'traincase',
    component: loadcomponents.load('studycenter/traincase/starttrain', 'views', ''),
    meta: {
      title: '开始学习'
    }
  },
  {
    path: '/startStudy',
    name: 'startStudy',
    component: loadcomponents.load('studycenter/coursedetail/start_study', 'views', ''),
    meta: {
      title: '开始学习'
    }
  },
  {
    path: '/enterexam',
    name: 'enterexam',
    component: loadcomponents.load('studycenter/exam/enterexam', 'views', ''),
    meta: {
      title: '进入考试'
    }
  },
  {
    path: '/startexam',
    name: 'startexam',
    component: loadcomponents.load('studycenter/exam/startexam', 'views', ''),
    meta: {
      title: '开始考试'
    }
  },
  {
    path: '/viewscore',
    name: 'viewscore',
    component: loadcomponents.load('studycenter/exam/viewscore', 'views', ''),
    meta: {
      title: '查看成绩'
    }
  },
  {
    path: '/privatecenter',
    name: 'privatecenter',
    component: loadcomponents.load('privatecenter', 'views', ''),
    meta: {
      title: '个人中心',
      requiresAuth: true
    }
  },
  {
    path: '/educationaltopic',
    name: 'educationaltopic',
    component: loadcomponents.load('educationaltopic', 'views', ''),
    meta: {
      title: '北京市高级社会工作师继续教育专题'
    }
  },
  {
    path: '/mistakes',
    name: 'mistakes',
    component: loadcomponents.load('privatecenter/mistakes', 'views', ''),
    meta: {
      title: '错题集'
    }
  },
  {
    path: '/mistakesdetail',
    name: 'mistakesdetail',
    component: loadcomponents.load('privatecenter/mistakes/mistakesdetail', 'views', ''),
    meta: {
      title: '错题详情'
    }
  },
  {
    path: '/declareddetail',
    name: 'declareddetail',
    component: loadcomponents.load('declaredtopic/declareddetail', 'views', ''),
    meta: {
      title: '课题内容详情'
    }
  },
  {
    path: '/subscriber',
    name: 'subscriber',
    component: loadcomponents.load('subscriber', 'views', ''),
    meta: {
      title: '预览首页'
    }
  },
  {
    path: '/traincase',
    name: '学习实训',
    component: loadcomponents.load('studycenter/traincase', 'views', ''),
    meta: {
      title: '学习实训'
    }
  },
  {
    path: '/subscriberCoursedetail',
    name: 'subscriber_coursedetail',
    component: loadcomponents.load('subscriber/coursedetail', 'views', ''),
    meta: {
      title: '预览课程'
    }
  },
  {
    path: '/subscriberContinue',
    name: 'subscriber_coursedetail_continue',
    component: loadcomponents.load('subscriber/coursedetail/continue', 'views', ''),
    meta: {
      title: '预览课程'
    }
  },
  {
    path: '/subscriberStartStudy',
    name: 'subscriberStartStudy',
    component: loadcomponents.load('subscriber/coursedetail/start_study', 'views', ''),
    meta: {
      title: '预览课程'
    }
  },
  {
    path: '/enroll',
    name: 'enroll',
    component: loadcomponents.load('enroll', 'views', '/studycenter'),
    meta: {
      title: '报名'
    }
  },
  {
    path: '/enrollUser',
    name: 'enrollUser',
    component: loadcomponents.load('studycenter/enroll/enrollUser', 'views', ''),
    meta: {
      title: '填写信息'
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: loadcomponents.load('studycenter/enroll/pay', 'views', ''),
    meta: {
      title: '支付'
    }
  },
  {
    path: '/enrollUserInfo',
    name: 'enrollUserInfo',
    component: loadcomponents.load('studycenter/enroll/enrollUserInfo', 'views', ''),
    meta: {
      title: '报名信息'
    }
  },
  {
    path: '/updateEnrollUserInfo',
    name: 'updateEnrollUserInfo',
    component: loadcomponents.load('studycenter/enroll/updateEnrollUserInfo', 'views', ''),
    meta: {
      title: '修改报名信息'
    }
  },
  {
    path: '/paySuccess',
    name: 'paySuccess',
    component: loadcomponents.load('studycenter/enroll/paySuccess', 'views', ''),
    meta: {
      title: '报名成功'
    }
  },
  // 考前培训
  {
    path: '/practicaltraining',
    name: 'practicaltraining',
    component: loadcomponents.load('practicaltraining', 'views', ''),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/trainCourseDetail',
    name: 'trainCourseDetail',
    component: loadcomponents.load('coursedetail', 'views', '/practicaltraining'),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/trainContinue',
    name: 'trainContinue',
    component: loadcomponents.load('continue', 'views', '/practicaltraining/coursedetail'),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/trainStartStudy',
    name: 'trainStartStudy',
    component: loadcomponents.load('start_study', 'views', '/practicaltraining/coursedetail'),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/trainTraincase',
    name: 'trainTraincase',
    component: loadcomponents.load('traincase', 'views', '/practicaltraining'),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/trainsTarttrain',
    name: 'trainsTarttrain',
    component: loadcomponents.load('starttrain', 'views', '/practicaltraining/traincase'),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: loadcomponents.load('statistics', 'views', ''),
    meta: {
      title: '可视化信息'
    }
  },
  {
    path: '/statistics1',
    name: 'statistics1',
    component: loadcomponents.load('statistics/statistics1', 'views', ''),
    meta: {
      title: '可视化信息'
    }
  },
  {
    path: '/checkPay',
    name: 'checkPay',
    component: loadcomponents.load('checkPay', 'views', '/studycenter/enroll'),
    meta: {
      title: '支票支付'
    }
  },
  {
    path: '/companyPay',
    name: 'companyPay',
    component: loadcomponents.load('companyPay', 'views', '/studycenter/enroll'),
    meta: {
      title: '对公转账'
    }
  },
  {
    path: '/orderpay',
    name: 'orderpay',
    component: loadcomponents.load('orderpay', 'views', '/studycenter/exam'),
    meta: {
      title: '支付'
    }
  },
  {
    path: '/orderpaySuccess',
    name: 'orderpaySuccess',
    component: loadcomponents.load('orderpaysuccess', 'views', '/studycenter/exam'),
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/goodspay',
    name: 'goodspay',
    component: loadcomponents.load('goodspay', 'views', '/payunify'),
    meta: {
      title: '支付'
    }
  },
  {
    path: '/courselive',
    name: 'courselive',
    component: loadcomponents.load('courselive', 'views', ''),
    meta: {
      title: '直播详情'
    }
  },
  {
    path: '/liveroom',
    name: 'liveroom',
    component: loadcomponents.load('courselive/liveroom', 'views', ''),
    meta: {
      title: '直播详情',
      requiresAuth: true
    }
  },
  {
    path: '/liveplay',
    name: 'liveplay',
    component: loadcomponents.load('courselive/liveplay', 'views', ''),
    meta: {
      title: '直播详情',
      requiresAuth: true
    }
  },
  {
    path: '/aitool',
    name: 'aitool',
    component: loadcomponents.load('aitool', 'views', ''),
    meta: {
      title: 'AI工具'
    }
  },
  {
    path: '/resourcelibrary',
    name: 'resourcelibrary',
    component: loadcomponents.load('resourcelibrary', 'views', ''),
    meta: {
      title: '资源库'
    }
  },
  {
    path: '/librarydetail',
    name: 'librarydetail',
    component: loadcomponents.load('librarydetail', 'views', '/resourcelibrary'),
    meta: {
      title: '资源库详情'
    }
  },
  {
    path: '/libraryvideo',
    name: 'libraryvideo',
    component: loadcomponents.load('libraryvideo', 'views', '/resourcelibrary'),
    meta: {
      title: '资源库视频'
    }
  },
  {
    path: '/wechatpayment',
    name: 'wechatpayment',
    component: loadcomponents.load('wechatpayment', 'views', ''),
    meta: {
      title: '微信支付'
    }
  },
  {
    path: '/paymentsuccess',
    name: 'paymentsuccess',
    component: loadcomponents.load('paymentsuccess', 'views', '/wechatpayment'),
    meta: {
      title: '微信支付成功'
    }
  },
  {
    path: '/paymenterror',
    name: 'paymenterror',
    component: loadcomponents.load('paymenterror', 'views', '/wechatpayment'),
    meta: {
      title: '微信支付失败'
    }
  }
]
Vue.use(Router)
const VueRouter = new Router({
  mode: 'history',
  routes,
  catchAll: { path: '*', redirect: '/' }
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

VueRouter.beforeEach(async function (to, from, next) {
  const requiresAuth = to.meta.requiresAuth
  const query = to.query
  var isAuthenticated = store.state.isLoggedIn
  if (query && query.accessToken) {
    try {
      await store.dispatch('login', query.accessToken)
      isAuthenticated = store.state.isLoggedIn
    } catch (err) {
      console.warn('Token 登录失败:', err)
    }
  }
  if (requiresAuth && !isAuthenticated) {
    // 保存目标路由到 Vuex
    store.commit('SET_REDIRECT_PATH', {
      path: to.path,
      query: to.query,
      params: to.params
    })
    console.log(store.getters.redirectPath)
    // next({
    //   path: '/'
    // })
    var redirectPath = {
      path: to.path,
      query: to.query,
      params: to.params
    }
    if (to.path !== '/') {
      eventBus.$emit('show-login', redirectPath)
    }
  } else {
    next()
  }
})
VueRouter.beforeResolve(async (to, from, next) => {
  const token = getLocal.getCookie('token') || null
  if (token && !store.state.isLoggedIn) {
    try {
      await store.dispatch('login', token) // 等待登录完成
    } catch (error) {
      console.error('自动登录失败:', error)
      localStorage.removeItem('token') // 删除无效 Token
      localStorage.removeItem('user')
      sessionStorage.setItem('user', null)
      store.dispatch('logout')
    }
  }
  next() // 确保路由解析继续
})

export default VueRouter
